// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Table container */
.vd_dashboard_container {
    width: 100%;
    background: white;
    border: 1px solid black;
    overflow: hidden;
}

.vd_table_wrapper {
    width: 100%;
    height: 55vh;
    overflow: auto;
}

.vd_validator_table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
    table-layout: fixed;
    background: white;
}

/* Header Styling */
.vd_validator_table thead {
    position: sticky;
    background-color: white;
    top: 0;
    z-index: 1;
}

.vd_validator_table thead th:hover {
    background-color: rgb(240, 240, 240);
}

.vd_header_cell {
    padding: 8px 16px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s;
    border: none;
    text-align: center;
    min-height: 60px;
}

.vd_header_content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    min-height: 40px;
}

.vd_header_text {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
}

.vd_header_text span {
    white-space: nowrap;
}

.vd_header_text .bottom-line {
    font-size: 0.9em;
}

.vd_header_cell:hover {
    background-color: rgba(255, 255, 255, 0.1);
}

/* Sort Icon */
.vd_sort_icon {
    display: inline-flex;
    align-items: center;
    margin-left: 4px;
    color: rgba(255, 255, 255, 0.7);
    font-size: 14px;
}

.vd_sort_icon .bracket {
    opacity: 0.5;
}

.vd_sort_icon .arrows {
    display: flex;
    align-items: center;
    margin: 0 1px;
}

.vd_sort_icon .up,
.vd_sort_icon .down {
    opacity: 0.3;
    color: black;
    transition: opacity 0.2s;
}

.vd_sort_icon.asc .up {
    opacity: 1;
    color: black;
}

.vd_sort_icon.desc .down {
    opacity: 1;
    color: black;
}

/* Add hover effect */
.vd_header_cell:hover .vd_sort_icon {
    color: rgba(255, 255, 255, 0.9);
}

.vd_header_cell:hover .vd_sort_icon .bracket {
    opacity: 0.7;
}

/* Table Body */
.vd_validator_table tbody tr {
    border-bottom: 1px solid black;
}

.vd_validator_table tbody tr:hover {
    background-color: rgb(240, 240, 240);
}

.vd_validator_table td {
    padding: 16px;
    color: black;
    border: none;
    text-align: center;
    vertical-align: middle;
}

/* Keep name column left-aligned */
.vd_validator_table td:first-child {
    text-align: left;
}

/* Address Cell */
.vd_address_cell {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

/* Copy Button */
.vd_copy_button {
    background: none;
    border: none;
    padding: 4px;
    cursor: pointer;
    color: var(--primary-color);
    opacity: 0.7;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    min-width: 24px;
    min-height: 24px;
}

.vd_copy_button:hover {
    opacity: 1;
    background-color: rgba(0, 36, 117, 0.1);
}

.vd_copy_button.copied {
    color: #22c55e;
    background-color: rgba(34, 197, 94, 0.1);
}

/* Status Styles */
.status-cell {
    font-weight: 500;
    text-align: center;
    display: block;
}

.status-cell.status-active {
    color: #22c55e;
}

.status-cell.status-jailed {
    color: #ef4444;
}

/* Column Widths */
.vd_validator_table th:nth-child(1),
.vd_validator_table td:nth-child(1) {
    width: 12%;
}

.vd_validator_table th:nth-child(2),
.vd_validator_table td:nth-child(2) {
    width: 12%;
}

.vd_validator_table th:nth-child(3),
.vd_validator_table td:nth-child(3) {
    width: 16%;
}

.vd_validator_table th:nth-child(4),
.vd_validator_table td:nth-child(4),
.vd_validator_table th:nth-child(5),
.vd_validator_table td:nth-child(5),
.vd_validator_table th:nth-child(6),
.vd_validator_table td:nth-child(6) {
    width: 8%;
}

.vd_validator_table th:nth-child(7),
.vd_validator_table td:nth-child(7),
.vd_validator_table th:nth-child(8),
.vd_validator_table td:nth-child(8) {
    width: 8%;
}

.vd_validator_table th:nth-child(9),
.vd_validator_table td:nth-child(9) {
    width: 10%;
}

.vd_validator_table th:nth-child(10),
.vd_validator_table td:nth-child(10) {
    width: 10%;
}

/* Scrollbar Styles */
.vd_table_wrapper::-webkit-scrollbar {
    width: 8px;
    height: 8px;
}

.vd_table_wrapper::-webkit-scrollbar-track {
    background: rgba(0, 36, 117, 0.05);
}

.vd_table_wrapper::-webkit-scrollbar-thumb {
    background: var(--primary-color, black);
    opacity: 0.8;
}

.vd_table_wrapper::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 36, 117, 0.9);
    cursor: pointer;
}

/* Loading State */
.validator_metrics_loader_card {
    width: 100%;
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: white;
    border: 1px solid black;
    color: var(--text-color);
    font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/styles/hype_staking/alllValidatorTable.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;IACI,WAAW;IACX,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA,mBAAmB;AACnB;IACI,gBAAgB;IAChB,uBAAuB;IACvB,MAAM;IACN,UAAU;AACd;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,iCAAiC;IACjC,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA,cAAc;AACd;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa;AACjB;;AAEA;;IAEI,YAAY;IACZ,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA,qBAAqB;AACrB;IACI,+BAA+B;AACnC;;AAEA;IACI,YAAY;AAChB;;AAEA,eAAe;AACf;IACI,8BAA8B;AAClC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA,kCAAkC;AAClC;IACI,gBAAgB;AACpB;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA,gBAAgB;AAChB;IACI,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,2BAA2B;IAC3B,YAAY;IACZ,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,uCAAuC;AAC3C;;AAEA;IACI,cAAc;IACd,wCAAwC;AAC5C;;AAEA,kBAAkB;AAClB;IACI,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,kBAAkB;AAClB;;IAEI,UAAU;AACd;;AAEA;;IAEI,UAAU;AACd;;AAEA;;IAEI,UAAU;AACd;;AAEA;;;;;;IAMI,SAAS;AACb;;AAEA;;;;IAII,SAAS;AACb;;AAEA;;IAEI,UAAU;AACd;;AAEA;;IAEI,UAAU;AACd;;AAEA,qBAAqB;AACrB;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,uCAAuC;IACvC,YAAY;AAChB;;AAEA;IACI,iCAAiC;IACjC,eAAe;AACnB;;AAEA,kBAAkB;AAClB;IACI,WAAW;IACX,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,uBAAuB;IACvB,wBAAwB;IACxB,eAAe;AACnB","sourcesContent":["/* Table container */\n.vd_dashboard_container {\n    width: 100%;\n    background: white;\n    border: 1px solid black;\n    overflow: hidden;\n}\n\n.vd_table_wrapper {\n    width: 100%;\n    height: 55vh;\n    overflow: auto;\n}\n\n.vd_validator_table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 14px;\n    table-layout: fixed;\n    background: white;\n}\n\n/* Header Styling */\n.vd_validator_table thead {\n    position: sticky;\n    background-color: white;\n    top: 0;\n    z-index: 1;\n}\n\n.vd_validator_table thead th:hover {\n    background-color: rgb(240, 240, 240);\n}\n\n.vd_header_cell {\n    padding: 8px 16px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: background-color 0.2s;\n    border: none;\n    text-align: center;\n    min-height: 60px;\n}\n\n.vd_header_content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 4px;\n    min-height: 40px;\n}\n\n.vd_header_text {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 2px;\n}\n\n.vd_header_text span {\n    white-space: nowrap;\n}\n\n.vd_header_text .bottom-line {\n    font-size: 0.9em;\n}\n\n.vd_header_cell:hover {\n    background-color: rgba(255, 255, 255, 0.1);\n}\n\n/* Sort Icon */\n.vd_sort_icon {\n    display: inline-flex;\n    align-items: center;\n    margin-left: 4px;\n    color: rgba(255, 255, 255, 0.7);\n    font-size: 14px;\n}\n\n.vd_sort_icon .bracket {\n    opacity: 0.5;\n}\n\n.vd_sort_icon .arrows {\n    display: flex;\n    align-items: center;\n    margin: 0 1px;\n}\n\n.vd_sort_icon .up,\n.vd_sort_icon .down {\n    opacity: 0.3;\n    color: black;\n    transition: opacity 0.2s;\n}\n\n.vd_sort_icon.asc .up {\n    opacity: 1;\n    color: black;\n}\n\n.vd_sort_icon.desc .down {\n    opacity: 1;\n    color: black;\n}\n\n/* Add hover effect */\n.vd_header_cell:hover .vd_sort_icon {\n    color: rgba(255, 255, 255, 0.9);\n}\n\n.vd_header_cell:hover .vd_sort_icon .bracket {\n    opacity: 0.7;\n}\n\n/* Table Body */\n.vd_validator_table tbody tr {\n    border-bottom: 1px solid black;\n}\n\n.vd_validator_table tbody tr:hover {\n    background-color: rgb(240, 240, 240);\n}\n\n.vd_validator_table td {\n    padding: 16px;\n    color: black;\n    border: none;\n    text-align: center;\n    vertical-align: middle;\n}\n\n/* Keep name column left-aligned */\n.vd_validator_table td:first-child {\n    text-align: left;\n}\n\n/* Address Cell */\n.vd_address_cell {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n}\n\n/* Copy Button */\n.vd_copy_button {\n    background: none;\n    border: none;\n    padding: 4px;\n    cursor: pointer;\n    color: var(--primary-color);\n    opacity: 0.7;\n    transition: all 0.2s;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 4px;\n    min-width: 24px;\n    min-height: 24px;\n}\n\n.vd_copy_button:hover {\n    opacity: 1;\n    background-color: rgba(0, 36, 117, 0.1);\n}\n\n.vd_copy_button.copied {\n    color: #22c55e;\n    background-color: rgba(34, 197, 94, 0.1);\n}\n\n/* Status Styles */\n.status-cell {\n    font-weight: 500;\n    text-align: center;\n    display: block;\n}\n\n.status-cell.status-active {\n    color: #22c55e;\n}\n\n.status-cell.status-jailed {\n    color: #ef4444;\n}\n\n/* Column Widths */\n.vd_validator_table th:nth-child(1),\n.vd_validator_table td:nth-child(1) {\n    width: 12%;\n}\n\n.vd_validator_table th:nth-child(2),\n.vd_validator_table td:nth-child(2) {\n    width: 12%;\n}\n\n.vd_validator_table th:nth-child(3),\n.vd_validator_table td:nth-child(3) {\n    width: 16%;\n}\n\n.vd_validator_table th:nth-child(4),\n.vd_validator_table td:nth-child(4),\n.vd_validator_table th:nth-child(5),\n.vd_validator_table td:nth-child(5),\n.vd_validator_table th:nth-child(6),\n.vd_validator_table td:nth-child(6) {\n    width: 8%;\n}\n\n.vd_validator_table th:nth-child(7),\n.vd_validator_table td:nth-child(7),\n.vd_validator_table th:nth-child(8),\n.vd_validator_table td:nth-child(8) {\n    width: 8%;\n}\n\n.vd_validator_table th:nth-child(9),\n.vd_validator_table td:nth-child(9) {\n    width: 10%;\n}\n\n.vd_validator_table th:nth-child(10),\n.vd_validator_table td:nth-child(10) {\n    width: 10%;\n}\n\n/* Scrollbar Styles */\n.vd_table_wrapper::-webkit-scrollbar {\n    width: 8px;\n    height: 8px;\n}\n\n.vd_table_wrapper::-webkit-scrollbar-track {\n    background: rgba(0, 36, 117, 0.05);\n}\n\n.vd_table_wrapper::-webkit-scrollbar-thumb {\n    background: var(--primary-color, black);\n    opacity: 0.8;\n}\n\n.vd_table_wrapper::-webkit-scrollbar-thumb:hover {\n    background: rgba(0, 36, 117, 0.9);\n    cursor: pointer;\n}\n\n/* Loading State */\n.validator_metrics_loader_card {\n    width: 100%;\n    height: 200px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: white;\n    border: 1px solid black;\n    color: var(--text-color);\n    font-size: 14px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
